<template>
  <div class="content-ques" tabindex="0" :aria-label="getAriaLabel($t(question.nameLocalizationKey))">
    <span class="content" v-html="replaceUnderscores($t(question.nameLocalizationKey))" />
  </div>
</template>

<script>
  export default {
    name: "QuestionContent",
    props: {
      question: {
        type: Object,
        required: true,
      }
    },
    methods: {
      replaceUnderscores: function(str) {
        return str.replace(/_{3,}/, (match) => {
          return `<ins>${match}</ins>`
        })
      },
      getAriaLabel: function(str) {
        return str.replace(/_{3,}/, this.$t("question_blank"))
      }
    }
  }

</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/variables.styl"
  .content-ques
    margin auto
    width 80%

    .content
      font font-opensans
      font-size 21pt
      ::v-deep ins
        color color-lime-green
      ::v-deep u
        font-size 21pt
</style>
